import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AbstractPaymentStoreRequest } from '@models/requests/abstract-payment-store-request.model';
import { TransactionResponse } from '@models/transaction-response';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderPaymentService {
  private http = inject(HttpClient);

  /**
   * Stores payment information for an order.
   *
   * @param {AbstractPaymentStoreRequest} body the payment request containing payment details
   * @param {string} hash the order hash for authentication
   *
   * @returns {Observable<TransactionResponse>} observable that emits the transaction response
   */
  public store(body: AbstractPaymentStoreRequest, hash: string): Observable<TransactionResponse> {
    return this.http.post<TransactionResponse>(
      `${environment.analyteCareApi}/api/v1/order/${body.order_id}/payment`,
      body,
      {
        headers: new HttpHeaders({ 'X-API-Hash': hash }),
      },
    );
  }
}
